import React, { useEffect } from "react";
import Header from "../components/Header";
import Preloader from "../components/Preloader";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import WhyDoingThis from "../components/WhyDoingThis";
import WhatWeDo from "../components/WhatWeDo";
import HowItWorks from "../components/HowItWorks";
import TrustBank from "../components/TrustBank";
import Pricing from "../components/Pricing";
import WhoWeServe from "../components/WhoWeServe";
import Testimonials from "../components/Testimonials";
import FreeReview from "../components/FreeReview";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import ContactFooter from "../components/ContactFooter";
import SoroBlogWidget from "../components/SoroBlogWidget";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ink min-h-screen antialiased">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <WhyDoingThis />
        <WhatWeDo />
        <HowItWorks />
        <TrustBank />
        <Pricing />
        <WhoWeServe />
        <Testimonials />
        <FreeReview />
        <FAQ />
        <FinalCTA />
        <ContactFooter>
          <SoroBlogWidget />
        </ContactFooter>
      </main>
    </div>
  );
};

export default Home;
